import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DeviceShowPage } from './device-show';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		DeviceShowPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(DeviceShowPage),
	],
})
export class DeviceShowPageModule {}



// WEBPACK FOOTER //
// ./src/pages/device-show/device-show.module.ts